import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=f86a189c&scoped=true&"
import script from "./Checkboxes.vue?vue&type=script&lang=js&"
export * from "./Checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=f86a189c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86a189c",
  null
  
)

export default component.exports